module.exports = __webpack_public_path__ + "img/free-flowers.9ad3aedb.png";